"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgTokensService", {
    enumerable: true,
    get: function() {
        return OrgTokensService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let OrgTokensService = class OrgTokensService {
    async apiTokenList(param) {
        var _param_req, _param_req_user_extra, _param_req_user;
        const fk_user_id = param.user.id;
        let includeUnmappedToken = false;
        if ((0, _nocodbsdk.extractRolesObj)(param.user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) {
            includeUnmappedToken = true;
        }
        // Check if user logged in via SSO
        const ssoClientId = ((_param_req = param.req) == null ? void 0 : _param_req.user) ? (_param_req_user = param.req.user) == null ? void 0 : (_param_req_user_extra = _param_req_user.extra) == null ? void 0 : _param_req_user_extra.sso_client_id : undefined;
        return new _PagedResponse.PagedResponseImpl(await _models.ApiToken.listWithCreatedBy(_extends({}, param.query, {
            fk_user_id,
            includeUnmappedToken,
            ssoClientId
        })), _extends({}, param.query, {
            count: await _models.ApiToken.count({
                includeUnmappedToken,
                fk_user_id,
                ssoClientId
            })
        }));
    }
    async apiTokenCreate(param) {
        var _param_req_user_extra, _param_req_user, _param_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ApiTokenReq', param.apiToken);
        // Get SSO client ID if user logged in via SSO
        const ssoClientId = (_param_req_user = param.req.user) == null ? void 0 : (_param_req_user_extra = _param_req_user.extra) == null ? void 0 : _param_req_user_extra.sso_client_id;
        const apiToken = await _models.ApiToken.insert(_extends({}, param.apiToken, {
            fk_user_id: param['user'].id,
            fk_sso_client_id: ssoClientId || null
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.ORG_API_TOKEN_CREATE, {
            tokenTitle: apiToken.description,
            userId: (_param_user = param.user) == null ? void 0 : _param_user.id,
            tokenId: apiToken.id,
            req: param.req
        });
        return apiToken;
    }
    async apiTokenDelete(param) {
        var _param_user;
        const fk_user_id = param.user.id;
        const apiToken = await _models.ApiToken.get(param.tokenId);
        if (!(0, _nocodbsdk.extractRolesObj)(param.user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN] && apiToken.fk_user_id !== fk_user_id) {
            _catchError.NcError._.notFound('Token not found');
        }
        const res = await _models.ApiToken.delete(param.tokenId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.ORG_API_TOKEN_DELETE, {
            tokenId: param.tokenId,
            tokenTitle: apiToken.description,
            userId: (_param_user = param.user) == null ? void 0 : _param_user.id,
            req: param['req']
        });
        return res;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
OrgTokensService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], OrgTokensService);
